import { render, staticRenderFns } from "./certInfoManage.vue?vue&type=template&id=b16a37ba&scoped=true"
import script from "./certInfoManage.vue?vue&type=script&lang=js"
export * from "./certInfoManage.vue?vue&type=script&lang=js"
import style0 from "./certInfoManage.vue?vue&type=style&index=0&id=b16a37ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16a37ba",
  null
  
)

export default component.exports